window.VH = window.VH === undefined ? {} : window.VH;

VH.OrderComment = {
    commentContainer : null,
    commentBt : null,
    toggleClass : null,
    editContainer : null,
    modal : null,
    modalBody : null,
    modalHeader : null,

    checkContainer : function checkContainer(toggle = true)
    {
        let _t = VH.OrderComment;

        if (_t.commentContainer.hasClass(_t.toggleClass)) {
            _t.commentContainer.removeClass(_t.toggleClass);
            _t.commentBt.html(_t.commentBt.data('close-text'))
        } else {
            _t.commentContainer.addClass(_t.toggleClass);
            _t.commentBt.html(_t.commentBt.data('open-text'));
        }
    },

    toggleActive : function toggleActive()
    {
        let _t = VH.OrderComment,
            bt = $(this),
            url = bt.data('url')
        ;
        $.get(url, {}, function (commentModel) {
            let rc = commentModel['show_to_user'] ? 'close' : 'open',
                ac = commentModel['show_to_user'] ?  'open' : 'close'
            ;
            bt
                .removeClass(bt.data(rc + '-class'))
                .addClass(bt.data(ac + '-class'))
                .attr('title', bt.data(ac + '-text'))
            ;
            bt.find('.btIcon')
                .removeClass(bt.data(rc + '-icon'))
                .addClass(bt.data(ac + '-icon'))
            ;
            if (commentModel['show_to_user']) {
                bt.closest('.list-group-item').removeClass('list-group-item-danger');
            } else {
                bt.closest('.list-group-item').addClass('list-group-item-danger');
            }
        });
    },

    submitEditForm : function submitEditForm(event)
    {
        let _t = VH.OrderComment,
            t = $(this);

        $.post(t.attr('action'), t.serialize(), function(data) {
            if (data.result === 'ok') {
                _t.editContainer.find('.itemText').html(data.html);
                _t.hideEditForm();
            } else {
                _t.modalBody.html(data.html);
            }
        });

        event.preventDefault();
        return false;
    },

    showEditForm : function showEditForm()
    {
        let _t = VH.OrderComment,
            t = $(this)
        ;
        _t.editContainer = t.closest('.list-group-item');

        $.get(t.data('url'), {}, function (data) {
            _t.modalHeader.html('Редактировать');
            _t.modalBody.html(data.html);
            _t.modal.modal('show');
            $('form', _t.modalBody).on('submit', _t.submitEditForm)
        });
    },

    hideEditForm : function hideEditForm()
    {
        let _t = VH.OrderComment;
        _t.modalBody.html('');
        _t.editContainer = null;
        _t.modal.modal('hide');
    },

    init : function init(listContainer, bt)
    {
        let _t = VH.OrderComment;
        _t.commentContainer = $(listContainer);
        _t.commentBt = $(bt);
        _t.toggleClass = _t.commentBt.data('toggle-class');
        _t.modal = $('#ajaxModal');
        _t.modalBody = $('.modal-body', _t.modal);
        _t.modalHeader = $('.modal-header h4', _t.modal);

        _t.commentContainer.on('click', '.btToggleActive', _t.toggleActive);
        _t.commentContainer.on('click', '.btEdit', _t.showEditForm);

        if (_t.commentContainer[0].scrollHeight > _t.commentContainer[0].clientHeight) {
            _t.commentBt.html(_t.commentBt.data('open-text'));
            _t.commentBt.on('click', _t.checkContainer);
        } else {
            _t.commentBt.hide();
        }
    }
};
